import { render, staticRenderFns } from "./work-findings.vue?vue&type=template&id=6da2c709&"
import script from "./work-findings.vue?vue&type=script&lang=js&"
export * from "./work-findings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports